import httpClient from "@/plugins/axios";

export const getAcknowledgments = async (targetType, targetId, page, acknowledged, pageSize, version = null) => {
    let url = `/admin/v1/acknowledgments/details/?target_type=${targetType}&target_id=${targetId}&page=${page}&page_size=${pageSize}`;

    if (acknowledged !== null) {
        url += `&acknowledged=${acknowledged}`;
    }

    if (version !== null) {
        url += `&version=${version}`;
    }

    const response = await httpClient.get(url);
    return response;
}


export const getPageAcknowledgmentDetails = async (pageId, page, acknowledged, version = null) => {
    let url = `/admin/v1/acknowledgments/details/?target_type=1&target_id=${pageId}&page=${page}`;

    if (acknowledged !== null) {
        url += `&acknowledged=${acknowledged}`;
    }

    if (version !== null) {
        url += `&version=${version}`;
    }

    const response = await httpClient.get(url);
    return response;
}

export const getAcknowledments = async (page, pageSize = 10, filters = {}) => {
    let url = `/admin/v1/acknowledgments/?page=${page}&page_size=${pageSize}`;

    if (filters.target_type) {
        url += `&target_type=${filters.target_type}`;
    }
    if (filters.target_id) {
        url += `&target_id=${filters.target_id}`;
    }
    if (filters.version) {
        url += `&version=${filters.version}`;
    }

    const response = await httpClient.get(url);
    return response;
}

export const deleteAcknowledgment = async (id) => {
    const response = await httpClient.delete(`/admin/v1/acknowledgments/${id}/`);
    return response;
}

export const getPageAcknowledgmentOverview = async (categoryId = null) => {
    let url = '/admin/v1/acknowledgments/pages/overview/';
    let query = {}
    if (categoryId) {
        query['category'] = categoryId
    }

    const response = await httpClient.get(url, {
        params: query
    });
    return response;
}

export const getResourceAcknowledgmentOverview = async () => {
    const response = await httpClient.get('/admin/v1/acknowledgments/resources/overview/');
    return response;
}
